import { create } from 'zustand'
import {
  DEFAULT_SILENCE_REMOVAL_SETTINGS,
  type SilencePreviewSummary,
  type SilenceRangesByItemId,
  type SilenceRemovalSettings,
} from '../utils/silence-removal-preview'

interface SilenceRemovalDialogState {
  isOpen: boolean
  itemIds: string[]
  settings: SilenceRemovalSettings
  rangesByItemId: SilenceRangesByItemId
  summary: SilencePreviewSummary | null
  isAnalyzing: boolean
  error: string | null
  open: (itemIds: string[]) => void
  close: () => void
  setSettings: (next: Partial<SilenceRemovalSettings>) => void
  setAnalyzing: (isAnalyzing: boolean) => void
  setAnalysisResult: (rangesByItemId: SilenceRangesByItemId, summary: SilencePreviewSummary) => void
  setError: (error: string | null) => void
  resetAnalysis: () => void
}

export const useSilenceRemovalDialogStore = create<SilenceRemovalDialogState>((set) => ({
  isOpen: false,
  itemIds: [],
  settings: DEFAULT_SILENCE_REMOVAL_SETTINGS,
  rangesByItemId: {},
  summary: null,
  isAnalyzing: false,
  error: null,
  open: (itemIds) =>
    set({
      isOpen: true,
      itemIds,
      rangesByItemId: {},
      summary: null,
      isAnalyzing: false,
      error: null,
    }),
  close: () =>
    set({
      isOpen: false,
      itemIds: [],
      rangesByItemId: {},
      summary: null,
      isAnalyzing: false,
      error: null,
    }),
  setSettings: (next) =>
    set((state) => ({
      settings: {
        ...state.settings,
        ...next,
      },
    })),
  setAnalyzing: (isAnalyzing) => set({ isAnalyzing }),
  setAnalysisResult: (rangesByItemId, summary) =>
    set({
      rangesByItemId,
      summary,
      error: null,
      isAnalyzing: false,
    }),
  setError: (error) => set({ error, isAnalyzing: false }),
  resetAnalysis: () =>
    set({
      rangesByItemId: {},
      summary: null,
      error: null,
      isAnalyzing: false,
    }),
}))